import React from "react"
import { withRouter } from "react-router-dom"
import { isMobile } from "react-device-detect"
import { view } from "react-easy-state"
import { Button, Table } from "antd"

import Header from "components/common/layouts/Header"
import Footer from "components/common/layouts/Footer"
import CourseList from "components/pages/students/courses/index/CourseList"
import UserDetail from "components/pages/students/users/show/UserDetails"
import ProfileEditForm from "components/pages/students/users/show/ProfileEditForm"
import ContentLoader from "components/common/ContentLoader"
import ContentLoadingFailed from "components/common/ContentLoadingFailed"

import globalStore from "store"
import UsersService from "services/users.service"
import SchoolsServices from "services/students/schools.service"

class ProfilePage extends React.Component {
  state = {
    profileEdit: false,
  }

  async componentDidMount() {
    const pageState = globalStore.ui.users.show
    await UsersService.show({ pageState })

    const pageStateSchool = globalStore.ui.students.schools.index
    await SchoolsServices.index({ pageState: pageStateSchool })
  }

  renderPageContent() {
    const pageState = globalStore.ui.users.show
    const { user, courses, payments, API_USERS_SHOW_STATUS } = pageState

    if (!API_USERS_SHOW_STATUS) return <ContentLoader />
    if (API_USERS_SHOW_STATUS === "pending") return <ContentLoader />
    if (API_USERS_SHOW_STATUS === "rejected") return <ContentLoadingFailed />

    return (
      <UserDetail
        user={user}
        courses={courses}
        payments={payments}
        basicDetailsTabContent={this.basicDetailsTabContent}
        myCoursesTabContent={this.myCoursesTabContent}
        paymentTabContent={this.paymentTabContent}
      />
    )
  }

  paymentTableColumns = () => {
    return [
      {
        title: "Course Name",
        dataIndex: "name",
        key: "name",
        render: (text) => <Button type="link">{text}</Button>,
      },
      {
        title: "Amount Paid",
        dataIndex: "amountPaid",
        key: "amountPaid",
        render: (amountPaid) => <span>&#8377; {amountPaid}</span>,
      },
      {
        title: "Payment ID",
        dataIndex: "paymentId",
        key: "paymentId",
      },
    ]
  }

  handleDiscardForm = () => {
    this.setState({ profileEdit: false })
  }

  basicDetailsTabContent = (user) => {
    const { profileEdit } = this.state

    if (!profileEdit) {
      return (
        <div className="basic-info">
          <ul>
            <li>
              <strong>Name:</strong> {user.name}
            </li>
            <li>
              <strong>Email:</strong> {user.email}
            </li>
            <li>
              <strong>Phone Number:</strong> {user.phone}
              {user.parents_phone && " (Parent's Phone)"}
            </li>
            <li>
              <strong>School:</strong> {user.school && user.school.name}
            </li>
          </ul>
          <div>
            <Button
              onClick={() => {
                this.setState({ profileEdit: true })
              }}
            >
              Edit
            </Button>
          </div>
        </div>
      )
    }

    return <ProfileEditForm user={user} discardForm={this.handleDiscardForm} />
  }

  myCoursesTabContent = (subscribedCourses) => {
    return (
      <div>
        <CourseList courses={subscribedCourses} style={{ marginTop: 0 }} />
      </div>
    )
  }

  paymentTabContent = (paymentTableData) => {
    return (
      <div>
        <Table columns={this.paymentTableColumns()} dataSource={paymentTableData} bordered />
      </div>
    )
  }

  render() {
    return (
      <div className={`page profile-page ${isMobile ? "mobile" : ""}`}>
        <Header />
        <div className="page-content">{this.renderPageContent()}</div>
        <Footer content={<h1>Footer</h1>} />
      </div>
    )
  }
}

export default withRouter(view(ProfilePage))
